import { initLogout } from "./helpers/logout.init";
import { Toast } from "./plugins/toastManager";

window.Toast = Toast;

$(function () {
  // ==============================
  // ✅ GLOBAL CSRF SETUP
  // ==============================
  const csrfTokenElement = document.querySelector('meta[name="layout-csrf-token"]');
  const csrfToken = csrfTokenElement ? csrfTokenElement.getAttribute("content") : null;

  if (csrfToken) {
    // Yardımcı: Sadece Menta.Web origin sınırları içindeki isteklere Token ekle
    const isSameOrigin = (url) => {
      if (typeof url !== "string") return true; // Request objesinde geçiyoruz
      return url.startsWith("/") || url.startsWith(window.location.origin);
    };

    // 1. jQuery AJAX Setup
    $(document).ajaxSend(function (event, xhr, settings) {
      if (!/^(GET|HEAD|OPTIONS|TRACE)$/i.test(settings.type) && !settings.crossDomain && isSameOrigin(settings.url)) {
        xhr.setRequestHeader("RequestVerificationToken", csrfToken);
      }
    });

    // 2. Native Fetch Override
    const originalFetch = window.fetch;
    window.fetch = function () {
      let [resource, config] = arguments;

      const url = typeof resource === "string" ? resource : resource ? resource.url : "";

      if (!config) {
        config = {};
      }

      if (config.method && !/^(GET|HEAD|OPTIONS|TRACE)$/i.test(config.method) && isSameOrigin(url)) {
        if (!config.headers) {
          config.headers = {};
        }
        if (config.headers instanceof Headers) {
          if (!config.headers.has("RequestVerificationToken")) {
            config.headers.append("RequestVerificationToken", csrfToken);
          }
        } else {
          config.headers["RequestVerificationToken"] = csrfToken;
        }
      }
      return originalFetch(resource, config);
    };
  }

  const $header = $("header");
  const $navHeader = $(".nav-header");
  const $scrollContainer = $(".snap-container");
  const $mobBtn = $(".mobile-menu-btn");
  const mobileMenuBtn = document.querySelector(".mobile-menu-btn");
  const header = document.querySelector("header");
  const $backToTop = $(".ind-cont");
  const $cartBag = $(".cart-bag");

  let ticking = false;

  const updateScrollState = () => {
    if ($header.hasClass("mobile-open")) return;

    const scrollPos = $scrollContainer.scrollTop();
    const isScrolled = scrollPos > 50;

    $header.toggleClass("scrolled", isScrolled);
    $navHeader.toggleClass("scrolled", isScrolled);
    scrollPos > 100 ? $backToTop.addClass("active") : $backToTop.removeClass("active");
  };

  const closeMobileMenu = () => {
    if ($header.hasClass("mobile-open")) {
      $header.removeClass("mobile-open");
      $mobBtn.removeClass("active");
      $scrollContainer.css("overflow-y", "auto");
      $(".dropdown-container").removeClass("is-open");

      // Menü kapandığında mevcut scroll durumunu kontrol et
      setTimeout(updateScrollState, 500);
    }
  };

  $mobBtn.on("click", function (e) {
    e.stopPropagation();
    if (!$header.hasClass("mobile-open")) {
      // Önce scrolled sınıfını temizle ki geçiş temiz olsun
      $header.removeClass("scrolled").addClass("mobile-open");
      $scrollContainer.css("overflow-y", "hidden");
      $(this).addClass("active");
    } else {
      closeMobileMenu();
    }
  });

  $scrollContainer.on("scroll", function () {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        updateScrollState();
        scrollIndicator();
        ticking = false;
      });
      ticking = true;
    }
  });

  $backToTop.on("click", ".scroll-tx", function () {
    $scrollContainer.css("scroll-snap-type", "none");
    $scrollContainer[0].scrollTo({ top: 0, behavior: "smooth" });
    setTimeout(() => {
      $scrollContainer.css("scroll-snap-type", "y mandatory");
    }, 600);
  });

  $(document).on("click", "a[data-target]", function (e) {
    const targetId = $(this).data("target");
    const $targetElement = $("#" + targetId);
    if ($targetElement.length) {
      e.preventDefault();
      $(".snap-container").css("scroll-snap-type", "none");
      $targetElement[0].scrollIntoView({ behavior: "smooth", block: "start" });
      setTimeout(() => {
        $(".snap-container").css("scroll-snap-type", "y mandatory");
      }, 700);
      closeMobileMenu();
    }
  });

  if (window.location.hash) {
    setTimeout(() => {
      const $target = $(window.location.hash);
      if ($target.length) {
        $target[0].scrollIntoView({ behavior: "smooth", block: "start" });
        window.history.replaceState(null, null, window.location.pathname);
      }
    }, 500);
  }

  $cartBag.on("click", function (e) {
    if ($(e.target).closest(".card-dropdown").length) return;

    // Eğer bu buton sadece bir linkse ve içinde dropdown yoksa, normal çalışmasına izin ver
    const href = $(this).attr("href");
    if (href && href !== "#" && href !== "javascript:void(0)" && $(this).find(".card-dropdown").length === 0) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();
    $(this).toggleClass("active");
  });

  $(document).on("click", function (e) {
    if (!$cartBag.is(e.target) && $cartBag.has(e.target).length === 0) {
      $cartBag.removeClass("active");
    }
  });

  $(".dropdown-toggle").on("click", function (e) {
    if (window.innerWidth < 768) {
      e.preventDefault();
      e.stopPropagation();
      $(this).closest(".dropdown-container").toggleClass("is-open");
    }
  });

  $(".nav-link, .dropdown-item").on("click", function () {
    if ($(this).is("a")) closeMobileMenu();
  });

  $(window).on("resize", function () {
    if (window.innerWidth >= 768) {
      closeMobileMenu();
      $mobBtn.removeClass("active"); // Ekran büyüdüğünde butonu sıfırla
    }
  });

  function scrollIndicator() {
    const container = $scrollContainer[0];
    const winScroll = container.scrollTop;
    const height = container.scrollHeight - container.clientHeight;
    if (height > 0) {
      const scrolled = (winScroll / height) * 100;
      $("#pr-bar").css("height", scrolled + "%");
    }
  }

  const initSwiper = () => {
    new Swiper(".education-swiper", {
      slidesPerView: 1,
      spaceBetween: 24,
      grabCursor: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
      pagination: { el: ".swiper-pagination" },
      breakpoints: { 640: { slidesPerView: 1 }, 1024: { slidesPerView: 1 }, 1536: { slidesPerView: 3 } },
    });

    const certSwiperEl = document.querySelector(".certificate-swiper");
    if (certSwiperEl) {
      new Swiper(certSwiperEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        grabCursor: true,
        loop: document.querySelectorAll(".certificate-swiper .swiper-slide").length > 1,
        effect: "fade",
        fadeEffect: { crossFade: true },
        speed: 600,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        on: {
          init(swiper) {
            _syncCert(swiper);
          },
          slideChange(swiper) {
            _syncCert(swiper);
          },
        },
      });

      function _syncCert(swiper) {
        const idx = swiper.realIndex;

        // Sayaç
        const cur = document.querySelector(".cert-nav-current");
        if (cur) cur.textContent = idx + 1;

        // Info kartları: active class toggle
        document.querySelectorAll(".cert-info-card").forEach((el, i) => {
          if (i === idx) {
            el.classList.add("active");
          } else {
            el.classList.remove("active");
          }
        });

        // Thumbnail active toggle
        document.querySelectorAll(".cert-thumb").forEach((el, i) => {
          if (i === idx) {
            el.classList.add("active");
          } else {
            el.classList.remove("active");
          }
        });
      }

      // Thumbnail tıklama
      document.querySelectorAll(".cert-thumb").forEach((thumb) => {
        thumb.addEventListener("click", () => {
          const tidx = parseInt(thumb.dataset.idx, 10);
          if (certSwiperEl.swiper) certSwiperEl.swiper.slideToLoop(tidx);
        });
      });

      // Özel ok butonları
      document.querySelector(".cert-btn-prev")?.addEventListener("click", () => {
        if (certSwiperEl.swiper) certSwiperEl.swiper.slidePrev();
      });
      document.querySelector(".cert-btn-next")?.addEventListener("click", () => {
        if (certSwiperEl.swiper) certSwiperEl.swiper.slideNext();
      });
    }

    const blogSlidesCount = document.querySelectorAll(".blog-swiper .swiper-slide").length;
    new Swiper(".blog-swiper", {
      slidesPerView: 1,
      spaceBetween: 32,
      grabCursor: true,
      loop: blogSlidesCount > 3,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        dynamicBullets: true,
      },
      breakpoints: {
        640: { slidesPerView: 2, spaceBetween: 32 },
        768: { slidesPerView: 2, spaceBetween: 32 },
        1024: { slidesPerView: 2, spaceBetween: 40 },
        1280: { slidesPerView: 3, spaceBetween: 40 },
        1536: { slidesPerView: 3, spaceBetween: 40 },
      },
    });
  };

  $("#faq-accordion").on("click", ".faq-item", function () {
    const $this = $(this);
    $(".faq-item").not($this).removeClass("active").find(".faq-content").slideUp(250);
    $(".faq-item").not($this).find("span").text("+");
    $this.toggleClass("active");
    $this.find(".faq-content").stop(true, true).slideToggle(250);
    $this.find("span").text($this.hasClass("active") ? "×" : "+");
  });

  // Initialize active FAQ items on load
  $(".faq-item.active").each(function () {
    $(this).find(".faq-content").show();
    $(this).find("span").text("×");
  });

  // ==============================
  // ✅ LOGOUT SYSTEM (jQuery Binding)
  // ==============================

  initLogout({
    endpoint: "/Auth/Logout",
    redirectTo: "/",
    debug: true,
  });

  // LOADING SPNN

  $(window).on("load", function () {
    const $loader = $("#loader-container");

    setTimeout(function () {
      // Doğrudan CSS sınıfını ekleyerek CSS tarafındaki transition'ı tetikliyoruz
      $loader.addClass("loaded");

      // Animasyon süresi (300ms) bittikten sonra DOM'dan kaldırıyoruz
      setTimeout(function () {
        $loader.remove();
        $("body").addClass("site-ready");
      }, 300);
    }, 150);
  });

  // Güvenlik önlemi
  setTimeout(function () {
    const $loader = $("#loader-container");
    if ($loader.length > 0) {
      $loader.addClass("loaded");
      setTimeout(() => $loader.remove(), 300);
    }
  }, 2500);

  // ==============================
  // ✅ GLOBAL BASKET EVENT LISTENER
  // ==============================
  // Sepetten ürün silindiğinde (header veya sepet sayfası) ilgili butonları güncelle
  window.addEventListener("basket:itemRemoved", function (e) {
    const removedCourseId = e.detail.courseId;

    // Sayfadaki ilgili "Sepete Git" butonunu bul ve "Sepete Ekle" yap
    const addToCartBtn = $(`.btn-go-to-cart[data-id="${removedCourseId}"]`);
    const buyNowBtn = $(".btn-go-to-checkout");

    if (addToCartBtn.length > 0) {
      // Butonu eski haline getir
      addToCartBtn
        .html('<i class="bx bx-basket"></i> Sepete Ekle')
        .removeClass("btn-go-to-cart bg-green-600 hover:bg-green-700 shadow-green-600/25")
        .addClass("btn-add-to-cart bg-primary shadow-primary/25");

      // Satın al butonunu resetle
      if (buyNowBtn.length > 0) {
        buyNowBtn.text("Hemen Satın Al").removeClass("btn-go-to-checkout").addClass("btn-buy-now");
      }
    }
  });

  initSwiper();
});
